import { JobStatusResponseDto } from "@/api";
import { PhotosService } from "@/api/services/PhotosService"
import { useQuery } from "@tanstack/react-query"

export const usePollPhotoResult = (jobId: string) => {
    const result = useQuery({
        queryKey: ['photo-result', jobId],
        queryFn: () => PhotosService.photosControllerGetJobStatus(jobId),
        refetchInterval: (query) => {
            // Stop polling when status is 'completed' or 'failed' or 'done'
            if (query.state.data?.status === 'completed' || 
                query.state.data?.status === 'failed' || 
                query.state.data?.status === 'done') {
                return false;
            }
            // Poll every 4 second while waiting/active/delayed
            return 10_000;
        },
        // Enable polling only when we have a valid jobId
        enabled: !!jobId,
    })

    return {
        ...result,
        isPending: result.data?.status == JobStatusResponseDto.status.WAITING || result.data?.status == JobStatusResponseDto.status.ACTIVE || result.data?.status == JobStatusResponseDto.status.DELAYED || result.isPending,
    };
}